import { render } from "./LevelsDropdown.vue?vue&type=template&id=7bf1fae9"
import script from "./LevelsDropdown.vue?vue&type=script&lang=js"
export * from "./LevelsDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__